/* ============================================================
   AI1 CART UNIFIER
   Loaded on every storefront page EXCEPT the homepage (via the
   AI1 Prestige Header section). Dawn's product forms normally
   open Dawn's own native cart-drawer. This intercepts those
   add-to-cart submits and routes them into the Prestige drawer
   (#p-cd) instead, so the whole site uses ONE cart experience.

   Technique: a capture-phase 'submit' listener on document fires
   BEFORE the <product-form> element's own bubble-phase handler.
   Calling stopImmediatePropagation() there prevents Dawn from
   running its handler (and thus from opening its drawer); we then
   perform the /cart/add.js request ourselves and call the global
   ai1OpenCart() provided by ai1-prestige.js.
   ============================================================ */
(function () {
  function prestigeReady() {
    return typeof window.ai1OpenCart === 'function' &&
           typeof window.ai1FetchCart === 'function' &&
           document.getElementById('p-cd');
  }

  function toast(msg, status) {
    if (typeof window.ai1TriggerToast === 'function') {
      window.ai1TriggerToast(msg, status);
    }
  }

  function isAddToCartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    var action = form.getAttribute('action') || '';
    // Must post to /cart/add and carry a variant id field.
    if (!/\/cart\/add/.test(action)) return false;
    if (!form.querySelector('[name="id"]')) return false;
    return true;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddToCartForm(form)) return;

    // Dynamic checkout ("Buy it now" / Shop Pay) is handled by Shopify
    // and routes straight to checkout — never reroute that.
    if (e.submitter && e.submitter.getAttribute('name') === 'checkout') return;

    // If the Prestige drawer isn't on the page, leave Dawn's default behaviour intact.
    if (!prestigeReady()) return;

    e.preventDefault();
    e.stopImmediatePropagation(); // blocks Dawn's product-form handler + native drawer

    var btn = e.submitter || form.querySelector('[name="add"]');
    /* AI1 PHASE 3.22 (DRAFT ONLY): ignore re-submits while an add is in flight. Rollback: delete guard + aria-busy lines. */
    if (btn && btn.classList.contains('ld')) return;
    if (btn) { btn.classList.add('ld'); btn.setAttribute('aria-busy', 'true'); }

    var formData = new FormData(form);

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (btn) { btn.classList.remove('ld'); btn.removeAttribute('aria-busy'); }
        if (!r.ok || (r.data && r.data.status)) {
          toast((r.data && r.data.description) || 'Error updating cart', 'er');
          return;
        }
        toast('Success! Item Added', 'ok');
        window.ai1OpenCart(); // opens Prestige drawer + refreshes items, total & badge
      })
      .catch(function () {
        if (btn) { btn.classList.remove('ld'); btn.removeAttribute('aria-busy'); }
        toast('Error updating cart', 'er');
      });
  }, true); // <-- capture phase
})();
